<template>
    <modal
        :active="active"
        :large="true"
        title="Import fejl"
        @closed="$emit('closed', true)"
    >
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th class="row">Række</th>
                    <th class="field">Fejlbeskrivelse</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(error, index) in errors" :key="index">
                    <td>{{ index }}</td>
                    <td>
                        <ul class="error-list">
                            <li v-for="(field,index) in error" :key="index">{{ field[0] }}</li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>

        <template v-slot:footer class="has-space-between">
            <button class="button is-default" @click="$emit('closed', true)">Luk import</button>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'

export default {
    components: {
        Modal,
    },
    props: {
        active: Boolean,
        errors: Object,
    },
}
</script>

<style scoped>
    .row {
        width: 20%;
    }
    .field {
        width: 80%;
    }
    .error-list {
        list-style-type: disc;
    }
</style>